import Vue from "vue";
import Vuex from "vuex";
import registration from "./registration";
import auth from "./auth";
import ui from "./ui";
import service from "./service";
import plugins from "./plugins";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    registration,
    auth,
    ui,
    service
  },
  plugins
});

export default store;
